export default {
      id: "es-pv-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#es-pv",
      toString: function () {
        return this.url;
      }
    }